import React, { useState, useEffect } from "react";
import { AppFooter, AppHeader } from "../../components/organisms";
import {
  AnalyticsService,
  notificationSchedulerTime,
  apiPost,
  getNotifications
} from "../../utils";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { Spinner, Title } from "../../components/atoms";
import moment from "moment";
import { OrderRow } from "../PastOrders/Detail/OrderRow";
import { useNavigate } from "react-router-dom";
import { GETORDERLISTWITHSTATUS, GETORDERLISTWITHSTATUS_V2 } from "../../api/apiConfig";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import { Stack } from "@mui/material";
import { FaBackspace, FaChevronLeft } from "react-icons/fa";
import { useMediaQuery } from "react-responsive";

const PastOrders = () => {
  toast.dismiss();
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 900px)' })

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const Signout = () => {
    navigate("/");
    const userEmail = localStorage.getItem("userEmail");
    AnalyticsService.logEvent("USER_LOGGED_OUT", {
      userEmail: userEmail,
    });
    AnalyticsService.identifyUser(null);
    AnalyticsService.clearUserProperties();
    localStorage.clear();
    localStorage.setItem("isAuthenticated", false);
    AnalyticsService.logEvent("USER_LOGGED_OUT_SUCCESSFULLY");
  };
  const onOrderDetails = (
    customer,
    date,
    value,
    orderNumber,
    url,
    customerAddress,
    isNewOrder,
    orderId,
    note,
    lineItems
  ) => {
    navigate("/pastOrderDetails", {
      state: {
        customer,
        date,
        value,
        orderNumber,
        url,
        customerAddress,
        isNewOrder,
        orderId,
        note,
        lineItems
      },
    });
    AnalyticsService.logEvent("PAST_ORDER_DETAILS_VIEWED", {
      customerName: customer ? customer : "N/A",
      date: date,
      orderNumber: orderNumber,
      productURL: url,
      customerAddress: customerAddress ? customerAddress : "N/A",
    });
  };
  const [data, setData] = useState();
  const [dataTry, setDataTry] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [page,setPage]=useState(1)
  const vendor = localStorage.getItem("userName");
  const numOfNewOrders = useSelector(
    (state) => state.notifications.numOfNewOrders
  );
  useEffect(() => {
    const interval = setInterval(
      () => getNotifications(numOfNewOrders, dispatch, navigate),
      notificationSchedulerTime
    );
    return () => clearInterval(interval);
  }, [numOfNewOrders]);

  useEffect(() => {
    AnalyticsService.logEvent("PAST_ORDER_PAGEVIEW");
    getPastOrders();
    getTryBeforeBuyOrders();
    window.history.pushState(null, document.title, window.location.href);
    window.addEventListener("popstate", function (event) {
      window.history.pushState(null, document.title, window.location.href);
    });
  }, []);

  const getPastOrders = async () => {
    setIsLoading(true);
    const response = await apiPost(GETORDERLISTWITHSTATUS_V2, {
      vendor: vendor,
      status: 4,
    });
    const res = response.data;
    if (res) {
      
      setData(res.data);
    }
    setIsLoading(false);
  };
  const getTryBeforeBuyOrders = async () => {
    setIsLoading(true);
    const response = await apiPost(GETORDERLISTWITHSTATUS_V2, {
      vendor: vendor,
      status: 4,
      isTryBeforeYouBuy: true,
    });
    const res = response.data;
    if (res) {
      setDataTry(res.data);
    }
    setIsLoading(false);
  };
  return (
    <div className="dashboardSec">
      <AppHeader Signout={Signout} />
      <div className="dashboard-content">
        <div className="pastOrders-container">
          <div className="scrollbar-container-past body" style={{marginLeft:'10px'}}>
    { /* <Title text={"Past orders"} className={"past-orders-title"} /> */}
            <div className="spinnerDivPast">
              <Spinner color={"black"} loading={isLoading} size={40} />
            </div>
            <Stack direction={"row"}  style={{position:'fixed',width:'100%',background:'#fff',paddingBottom:'15px',marginTop:isTabletOrMobile && '-10px'}}>
              <div style={{border:'none',height:'40px'}} className="backNavCls" onClick={()=>navigate('/dashboard')}>
                  <FaChevronLeft className={'menuIconCls'} color={'black'} size={isTabletOrMobile?20:38} />
                  <Title text={"Back"} className="backTextStyles" />
              </div>
              <Tabs>
              <TabList>
                <Tab onClick={()=>setPage(1)}>All ORDERS</Tab>
                <Tab onClick={()=>setPage(2)}>TRY BEFORE YOU BUY</Tab>
              </TabList>
                <TabPanel></TabPanel>
                <TabPanel></TabPanel>
              </Tabs>
            </Stack>
              <Tabs style={{paddingLeft:!isTabletOrMobile&&'120px',width:'100%'}}>
                <TabList className="displayNone"> <Tab></Tab></TabList>
                {page==1 &&<TabPanel>
                  <div className="upper-spacing">
                    <div
                      className={isLoading ? "displayNone" : "pastOrdersSection"}
                    >
                      <>
                        {data &&
                          data.map((e) => {
                            const dateValue = e.updatedDate
                              ? moment(e.orderDate.slice(0, 10)).format(
                                "DD.MM.YYYY"
                              )
                              : "N/A";
                            const orderVal = e.orderValue.toLocaleString({
                              maximumFractionDigits: 2,
                            });
                            const noOfItems = e.lineItems.length;
                            return (
                              <OrderRow
                                key={e.orderId}
                                viewOnClick={() =>
                                  onOrderDetails(
                                    e.customerName,
                                    dateValue,
                                    e.orderValue,
                                    e.orderNo,
                                    e.orderURL,
                                    e.shippingAddress,
                                    e.newOrder,
                                    e.orderId,
                                    e.note,
                                    e.lineItems
                                  )
                                }
                                noOfItems={noOfItems ? noOfItems : "N/A"}
                                orderDate={dateValue}
                                orderDeliveryDate={e.orderDeliveryDateTime ? moment(
                                  e.orderDeliveryDateTime
                                ).format("DD.MM.YYYY") : "N/A"}
                                orderRef={e.orderNo}
                                orderValue={orderVal}
                              />
                            );
                          })}
                      </>
                    </div>
                  </div>
                </TabPanel>}
                {page==2 &&<TabPanel>
                  <div className="upper-spacing">
                    <div
                      className={isLoading ? "displayNone" : "pastOrdersSection"}
                    >
                      <>
                        {dataTry &&
                          dataTry.map((e) => {
                            const dateValue = e.updatedDate
                              ? moment(e.orderDate.slice(0, 10)).format(
                                "DD.MM.YYYY"
                              )
                              : "N/A";
                            const orderVal = e.orderValue.toLocaleString({
                              maximumFractionDigits: 2,
                            });
                            const noOfItems = e.lineItems.length;
                            return (
                              <OrderRow
                                key={e.orderId}
                                viewOnClick={() =>
                                  onOrderDetails(
                                    e.customerName,
                                    dateValue,
                                    e.orderValue,
                                    e.orderNo,
                                    e.orderURL,
                                    e.shippingAddress,
                                    e.newOrder,
                                    e.orderId,
                                    e.note,
                                    e.lineItems
                                  )
                                }
                                noOfItems={noOfItems ? noOfItems : "N/A"}
                                orderDate={dateValue}
                                orderDeliveryDate={e.orderDeliveryDateTime ? moment(
                                  e.orderDeliveryDateTime
                                ).format("DD.MM.YYYY") : "N/A"}
                                orderRef={e.orderNo}
                                orderValue={orderVal}
                              />
                            );
                          })}
                      </>
                    </div>
                  </div>
                </TabPanel>}
              </Tabs>
          </div>
        </div>
      </div>
      {/* <AppFooter /> */}
    </div>
  );
  //@TCS_END@
};

export default PastOrders;
